import 'style/style.scss';
import aClass from 'vendor/aClass';
import HomePage from 'pages/HomePage';
import {Intro} from 'components/Intro';
import {Animations} from 'components/Animations';
import {Video} from 'components/Video';
import {Form} from 'components/Form';

$(document).ready(() => {

    const homePage = new HomePage();
    homePage.init();

    const intro = new Intro();
    intro.init();

    const animations = new Animations();
    animations.init();

    const video = new Video();
    video.init();

    const form = new Form();
    form.init();

    const url_string = window.location.href,
        url = new URL(url_string),
        scrollToParam = url.searchParams.get("scrollTo");


    if(scrollToParam && scrollToParam === '1') {
        if(scrollToParam.length > 0) {
            TweenMax.to($('html, body'), 1, {
                scrollTop: $('.js-sec-4').offset().top - $('.c-navigation').outerHeight(),
                ease: Power2.easeOut
            });
        }
    } else if(scrollToParam && scrollToParam === '2') {
        if(scrollToParam.length > 0) {
            TweenMax.to($('html, body'), 1, {
                scrollTop: $('.js-sec-5').offset().top - $('.c-navigation').outerHeight(),
                ease: Power2.easeOut
            });
        }
    }

});


// WEBPACK FOOTER //
// ./static/js/index.js